// core version + navigation, pagination modules:
import Swiper from 'swiper'
import {Autoplay, Navigation, Pagination, Parallax} from 'swiper'
import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class Sliders {
  constructor(slider, index) {
    this.slider = slider
    this.index = index
    this.slides = Array.from(this.slider.querySelectorAll('.swiper-slide'))

    this.options = this.setOptions()
    this.initSlider()
  }

  setOptions() {
    let options = {}

    if (this.slider.classList.contains('swiper--home')) {
      // if (window.innerWidth < 1024) {
      //   options = {
      //     modules: [Pagination, Autoplay, Navigation],
      //     slidesPerView: 1,
      //     spaceBetween: 0,
      //     speed: 1500,
      //     autoHeight: true,
      //     autoplay: {
      //       delay: 4000,
      //       disableOnInteraction: false,
      //     },
      //     rewind: true,
      //   }
      // } else {
      options = {
        modules: [Pagination, Autoplay, Navigation],
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1500,
        autoHeight: true,
        autoplay: {
          delay: 7000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        rewind: true,
        on: {
          init: function (swiper) {
            slideHeroAnimate(swiper.slides[swiper.activeIndex], true)
          },
          slideChange: function (swiper) {
            slideHeroAnimate(swiper.slides[swiper.activeIndex], false)
            checkVideo(swiper.slides[swiper.activeIndex].querySelector('video'))
          },
        },
      }
      // }
    } else if (this.slider.classList.contains('swiper--products')) {
      options = {
        modules: [Pagination, Navigation],
        slidesPerView: 1,
        spaceBetween: 40,
        watchOverflow: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 60,
          },
        },
      }
    }
    // else if (this.slider.classList.contains('swiper--images')) {
    //   options = {
    //     modules: [Parallax],
    //     slidesPerView: 1.2,
    //     spaceBetween: 40,
    //     breakpoints: {
    //       768: {
    //         slidesPerView: 2,
    //         spaceBetween: 60,
    //       },
    //     },
    //   }
    // }

    return options
  }

  initSlider() {
    console.debug('  -> Sliders init')
    let swiperInstance = new Swiper(this.slider, this.options)

    swiperInstance.init()
    this.swiperInstance = swiperInstance

  }

  destroy() {
    console.debug('  -> Sliders destroy')
    this.swiperInstance.destroy()
  }

  static destroyAll() {
    console.debug('  -> Sliders destroy all')
    Sliders.items.forEach((slider) => {
      slider.destroy()
    })
  }

  static init() {
    console.debug('== Sliders components ==')
    Sliders.items = Array.from(document.querySelectorAll('.swiper')).map(
      (slider, index) => new Sliders(slider, index)
    )
  }
}

function slideHeroAnimate(slide, first) {
  const title = slide.querySelector('.title')
  const text = slide.querySelector('.text')
  const pagination = slide.querySelector('.pagination-progress')
  const line = slide.querySelector('.white-line')

  line.style.transition = "none"
  line.classList.remove("active")

  const tlSlideHero = gsap.timeline()

  tlSlideHero
    .from(pagination, {
      autoAlpha: 0,
      delay: 1.5,
      duration: 1,
      ease: 'expo.out',
      onComplete: function(){ 
        first ? line.style.transition = "width 4.5s linear": line.style.transition = "width 6s linear";
        line.classList.add("active")
      }
    })
    .from(title, {
      autoAlpha: 0,
      delay: -0.75,
      duration: 1,
      x: -20,
      ease: 'expo.out',
    })
    .from(text, {
      autoAlpha: 0,
      delay: -0.75,
      duration: 1,
      x: -20,
      ease: 'expo.out',
    })

  tlSlideHero.call(() => {
    tlSlideHero.kill();
  });
}

function checkVideo(video) {
  const videos = document.querySelectorAll('.swiper-slide video')
  if(video){
    // console.log('Play video: ', video)
    video.load()
    video.play()
  } else{
    // console.log('Pause all videos.')
    videos.forEach((video) => {
      video.pause()
    })
  }
}